import React from 'react';

const NurseryPayContent: React.FC = () => (
  <div>
    <p>施設側で決済を行います。</p>
  </div>
);

export default NurseryPayContent;
